import React from "react";
import PropTypes from "prop-types";
import STRINGS from "Constants/Strings";
import NumberFormat from "react-number-format";
import MaskedInput from "react-text-mask";
import AppConstants from "Constants/AppConstants";
import AuthBody from "../Common/AuthBody/AuthBody";
import Stepper from "../Common/Stepper/Stepper";
import VALIDATIONS from "../../Constants/ValidationList";
import checkErrors from "../../Utils/InputValidator";
import ROUTES from "../../Constants/AppConstants";

class BusinessOnline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      businessOnlineBanking: "",
      businessOnlineBankingErrorList: "",
    };
  }

  componentDidMount() {
    const { getDataFromServer } = this.props;

    getDataFromServer(
      AppConstants.APPLICATIONSTEP.BUSINESS_ONLINE,
      (response) => {
        this.setFormData(response);
      }
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { activeProduct } = this.props;
    if (prevProps !== this.props) {
      this.setState({
        businessOnlineBanking:
          activeProduct?.businessOnlineBanking !== "" &&
          activeProduct?.businessOnlineBanking !== undefined
            ? activeProduct?.businessOnlineBanking
            : "no",
      });
    }
  }

  setFormData = () => {};

  handleContinue = () => {
    const { handleContinue } = this.props;
    const { businessOnlineBanking } = this.state;
    let valid = true;

    if (valid) {
      handleContinue({ businessOnlineBanking });
    }
  };

  handleBack = () => {
    const { handleBack } = this.props;
    handleBack(AppConstants.APPLICATIONSTEP.BUSINESS_ONLINE);
  };

  handleChoice = (name, value) => {
    const errorObject = `${name}${STRINGS.COMMON.ERROR_LIST}`;
    this.setState({
      [name]: value,
      [errorObject]: "",
    });
  };

  handleChange = (event) => {
    console.log("handleChange", event?.target?.name, event?.target?.value);
    const { errors } = this.state;
    const errorObject = `${event?.target.name}${STRINGS.COMMON.ERROR_LIST}`;

    let eventName = event?.target.name;
    let eventValue = event?.target.value;

    this.setState(
      {
        [eventName]: eventValue,
        [errorObject]: "",
      },
      () => {
        const { formIsValid } = this.state;
        if (!formIsValid) this.verifyData();
      }
    );
  };

  verifyData = () => {
    let formIsValid = true;

    const {
      businessOnlineBanking,
      businessOnlineBankingErrorList,
    } = this.state;

    const businessOnlineBankingRes = checkErrors(
      businessOnlineBanking,
      VALIDATIONS.BUSINESS_ONLINE.ONLINE_BANKING
    );

    this.setState({
      businessOnlineBankingErrorList: businessOnlineBankingRes,
    });

    if (businessOnlineBankingRes.length > 0) {
      formIsValid = false;
    }

    return formIsValid;
  };

  render() {
    const { steps, activeStepID } = this.props;
    const {
      businessOnlineBanking,
      businessOnlineBankingErrorList,
    } = this.state;
    console.log(steps, activeStepID);

    const actionComponent = (
      <div className="[ property-details-container ]">
        <Stepper steps={steps} active={activeStepID} />

        <div className="[ form-title ]">{STRINGS.BUSINESS_ONLINE.TITLE}</div>

        <div className="[ form-container ]">
          <div className="[ row ]">
            <div className="[ col-sm-12 col-lg-8 ]">
              <div className="[ mb-3 ]">
                <div className="[ form-label ]">
                  {STRINGS.BUSINESS_ONLINE.FORM.ACCOUNT_ONLINE_BANKING_LABEL}
                </div>
                <div className="[ row ] [ custom-radios ]">
                  <div className="[ col-6 ]">
                    <button
                      type="submit"
                      className={
                        businessOnlineBanking === "yes"
                          ? "[ btn custom-radio-selected ]"
                          : "[ btn custom-radio-unselected ]"
                      }
                      name="businessOnlineBanking"
                      onClick={(event) =>
                        this.handleChoice("businessOnlineBanking", "yes", event)
                      }
                    >
                      {STRINGS.COMMON.CHOICE.YES}
                    </button>
                  </div>

                  <div className="[ col-6 ]">
                    <button
                      type="submit"
                      className={
                        businessOnlineBanking === "no"
                          ? "[ btn custom-radio-selected ] "
                          : "[ btn custom-radio-unselected ] "
                      }
                      name="businessOnlineBanking"
                      onClick={(event) =>
                        this.handleChoice("businessOnlineBanking", "no", event)
                      }
                    >
                      {STRINGS.COMMON.CHOICE.NO}
                    </button>
                  </div>
                </div>
                <div className="[ error-msg ]">
                  {businessOnlineBankingErrorList[0]}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="button"
                className="[ btn  submit-btn ] [ w-100 ]"
                onClick={this.handleContinue}
              >
                {STRINGS.COMMON.CONTINUEBTN}
              </button>
            </div>
          </div>
        </div>
      </div>
    );

    return (
      <AuthBody
        actionComponent={actionComponent}
        memberCreation
        handleBack={this.handleBack}
      />
    );
  }
}

BusinessOnline.propTypes = {
  getDataFromServer: PropTypes.func,
  handleContinue: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

BusinessOnline.defaultProps = {
  getDataFromServer: () => {},
  handleContinue: () => {},
  steps: [],
  activeStepID: -1,
};

export default BusinessOnline;
